import { User } from 'oidc-client-ts';
import { getSentinelAuthority, sentinelId } from './config';

const getSessionStorageKey = (): string => {
  const clientId = sentinelId();
  const authority = getSentinelAuthority();
  return `oidc.user:${authority}:${clientId}`;
};

export const getUserToken = (): User | null => {
  const oidcStorage = sessionStorage.getItem(getSessionStorageKey());
  if (!oidcStorage) {
    return null;
  }
  return User.fromStorageString(oidcStorage);
};

interface TokenInfo {
  accessToken?: string;
  idToken?: string;
  refreshToken?: string;
  profile: Record<string, unknown>;
  expires_in?: number;
}

export const getTokens = (): TokenInfo => {
  const user = getUserToken();
  return {
    accessToken: user?.access_token,
    idToken: user?.id_token,
    refreshToken: user?.refresh_token,
    profile: user?.profile || {},
    expires_in: user?.expires_in,
  };
};
